import React from 'react';
import ReactSVG from "react-svg";
import classnames from 'classnames';
import {NeuroMessage} from '@ignitesales/neuro-application/src/neuro-guide';

const Footer = ({className}) => {
  const classes = classnames(
    'footer',
    className
  );

  return <>
    <footer className={classes}>
      <div>
        <NeuroMessage id="footer.message" tagName='p'/>
      </div>
      <div className="equal-housing-lender">
        <img className="equal-housing-lender-img" src="/classpath/assets/images/svg/logo-equal-housing-lender-grey.svg" />
        <div className="equal-housing-lender-text">Federally Insured by NCUA</div>
      </div>
    </footer>
  </>;
};

export default Footer;